import React from 'react';
import PropTypes from 'prop-types';

const Text = props => {
  return <p {...props}>{props.children}</p>;
};

Text.propTypes = {
  /** Content for component *required */
  children: PropTypes.node.isRequired,
};

export default Text;
